import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './UserProfile.css';

const UserProfile = () => {
  const [userData, setUserData] = useState({
    username: '',
    role: ''
  });
  const navigate = useNavigate();

  useEffect(() => {
    // Get user data from localStorage
    const username = localStorage.getItem('username') || 'Usuario';
    const role = localStorage.getItem('userRole') === 'admin' ? 'Administrador' : 'Usuario';
    
    setUserData({
      username,
      role
    });
  }, []);

  const handleBack = () => {
    navigate(-1); // Go back to previous page
  };

  return (
    <div className="user-profile-container">
      <div className="">
        <div className="profile-header">
          <div className="profile-avatar">
            <i className="fas fa-user-circle"></i>
          </div>
          <h2>Perfil de Usuario</h2>
        </div>
        
        <div className="profile-content">
          <div className="info-section">
            <h3>Información de la Cuenta</h3>
            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">Usuario</span>
                <div className="info-value">
                  <i className="fas fa-user"></i>
                  <span>{userData.username}</span>
                </div>
              </div>
              <div className="info-item">
                <span className="info-label">Rol</span>
                <div className="info-value">
                  <i className="fas fa-user-shield"></i>
                  <span>{userData.role}</span>
                </div>
              </div>
              <div className="info-item">
                <span className="info-label">Último inicio</span>
                <div className="info-value">
                  <i className="far fa-clock"></i>
                  <span>{new Date().toLocaleDateString('es-AR')}</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="action-buttons">
            <button 
              onClick={handleBack}
              className="btn btn-secondary"
            >
              <i className="fas fa-arrow-left"></i> Volver al inicio
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
